module.exports = __webpack_public_path__ + "static/media/veneto-village-13.16e8bd0b.jpg";